/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFieldStore } from '../../axios/customFieldStore'
import type {
	CustomFieldStoreError,
	CustomFieldStorePathParams,
	CustomFieldStoreRequest,
	CustomFieldStoreResponse,
} from '../../types/CustomFieldStore'

export const customFieldStoreMutationKey = () => [{ url: '/:organisation/custom_fields' }] as const

export type CustomFieldStoreMutationKey = ReturnType<typeof customFieldStoreMutationKey>

export type CustomFieldStoreVariables = {
	organisation: CustomFieldStorePathParams['organisation']
	data: CustomFieldStoreRequest
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::store */
export function useCustomFieldStore<TContext = unknown>(
	options?: UseMutationOptions<
		CustomFieldStoreResponse,
		AxiosError<CustomFieldStoreError>,
		CustomFieldStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customFieldStoreMutationKey(),
		mutationFn: ({ organisation, data }: CustomFieldStoreVariables) =>
			customFieldStore(organisation, data, config).then(res => res.data),
		...options,
	})
}
